import type { AnalyticsEvent, AnalyticsParams } from '../events';
import { TrackingDestination } from './TrackingDestination';

/** Tracking for debugging events in the console. */
export class DebugDestination extends TrackingDestination {
  protected isEnabled(): boolean {
    return import.meta.env.VITE_ENVIRONMENT !== 'prod';
  }

  protected send(event: AnalyticsEvent, payload: AnalyticsParams): void {
    // eslint-disable-next-line no-console
    console.debug('[track]', event, payload);
  }
}
